import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { universalSchedulerDefaults } from '../../data/universalSchedulerDefaults';
import SlideUpComponent from '../SlideUp/SlideUpComponent';
import UniversalScheduler from '../UniversalScheduler/UniversalSchedulerV2';
import { PullUpSchedulerStyles } from './PullUpSchedulerStyles';

/**
 * Scheduler popup to be shown for setting appointments across site
 * @param {Boolean} setIsSchedulerOpen Used to show/hide the scheduler popup
 * @param {Object} data WP data setting strings and images to be used across scheduler
 * @param {Object} localizationStrings Data setting translatable strings across scheduler
 * @param {Object} leadValues Used for appointments lead, campaign and channel values stored
 * @param {Object} AdditionalQuestions Optional param, use if you want to override scheduler form questions
 * @param {String} customClass Custom class to be used when CSS has to be overriden on a particular page
 */
const PullUpSchedulerV2 = ({
  data,
  AdditionalQuestions,
  PaidCampaign,
  setIsSchedulerOpen,
  EntityCampaign = false,
  AssignOwner = false,
  localizationStrings = false,
  customClass = false,
  doElite = false,
  isTaxServicesLLC,
  Team = false,
  setSchedulerOpen = null,
  EForm = false,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [stringDefaults, setStringDefaults] = useState(
    universalSchedulerDefaults //Localization strings, defaults to english
  );

  useEffect(() => {
    //Sets location strings when received as param
    if (localizationStrings) {
      setStringDefaults(localizationStrings);
    }
  }, [localizationStrings]);

  useEffect(() => {
    let leadValues = Cookies.get('leadValues');
    if (leadValues && Team) {
      leadValues = JSON.parse(leadValues);
      leadValues.team = Team
      Cookies.set('leadValues', leadValues);
    }
  }, [Team]);

  useEffect(() => {
    setTimeout(() => {
      //Small timeout before toggle to avoid render flick
      setIsActive(true);
    }, 50);

    return function cleanup() { };
  }, []);

  const close = () => {
    setIsSchedulerOpen(false);
    if (setSchedulerOpen) {
      setSchedulerOpen(false);
    }
  };

  return (
    <PullUpSchedulerStyles>
      <SlideUpComponent active={isActive} close={close}>
        <UniversalScheduler
          data={data || stringDefaults}
          AdditionalQuestions={AdditionalQuestions}
          onClose={close}
          PaidCampaign={PaidCampaign}
          EntityCampaign={EntityCampaign}
          language={localizationStrings.lang}
          customClass={customClass}
          AssignOwner={AssignOwner}
          doElite={doElite}
          isTaxServicesLLC={isTaxServicesLLC}
          EForm={EForm}
        />
      </SlideUpComponent>
    </PullUpSchedulerStyles>
  );
};

export default PullUpSchedulerV2;
